import React from "react"
import L10n from "lib/carrot-l10n"
import { TextLink } from "../atoms/links/TextLink"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

// view component when card is already activated
const ActivateDone = () => (
  <div className="mw6 center tc pa4-ns pv2">
    <h1 className="publico-text mt0 mb4 black">{l`carrotCard.activationDone`}</h1>
    <p className="lh-copy mt0 mb3 black-60">
      {l`carrotCard.activationDoneMessage`}
      <TextLink to="/talk-to-carrot">
        <span>{l`carrotCard.clickToContactSupportForCardActivation`}</span>
      </TextLink>
      {/* leave period outside of link */}.
    </p>
  </div>
)

export default ActivateDone
